import { Box } from "@chakra-ui/layout";
import Header from "./Header";
import SubHeader from "./SubHeader";
import { useWindowSize } from "infra/helpers/window";
import { useDetalhesHeader } from "./Header/hooks/useDetalhesHeader";
import { SubHeaderContainer } from "./styles";

function Layout({ children }: any) {
  const windowSize = useWindowSize();

  const isMobile = windowSize.width <= 992;
  const isMidSizeMobile = windowSize.width > 768 && windowSize.width <= 992;

  const { data: passos = [], isLoading, isFetching } = useDetalhesHeader();

  const passosConcluidos = passos.reduce((acc, value) => {
    return acc + (value.porcentagemConcluido ?? 0);
  }, 0);

  const totalDePassos = passos.length;
  const porcentagemConcluidaPassosCadastro =
    totalDePassos === 0 ? 0 : passosConcluidos / totalDePassos;

  const getSubHeaderMt = () => {
    if (isMobile) {
      if (isMidSizeMobile) {
        return "45px";
      }

      return 0;
    }

    if (totalDePassos && porcentagemConcluidaPassosCadastro < 100) {
      return "125px";
    }

    return "69px";
  };

  return (
    <Box minH="100vh" bg={"#f2f2f2"} maxW="100vw">
      <Box>
        <Header
          passos={passos}
          porcentagemConcluidaPassosCadastro={
            porcentagemConcluidaPassosCadastro
          }
          isLoadingPassos={isLoading}
          isFetchingPassos={isFetching}
        />

        <SubHeaderContainer mt={getSubHeaderMt()}>
          <SubHeader />
          <Box pt="32px" pb={"72px"}>
            {children}
          </Box>
        </SubHeaderContainer>
      </Box>
    </Box>
  );
}

export default Layout;
